import { useNavigate } from 'react-router-dom';
import { RootState, useAppSelector } from '../store';
import { userService } from '../Services/userService';
import { getBreakpoint } from '../utils/breakpoint';

const useUsers = () => {
    const navigate = useNavigate();
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const demo = useAppSelector((state: RootState) => state.environment.demoInstance as boolean);
    const windowWidth = useAppSelector((state: RootState) => state.environment.windowWidth);

    const handleNavigate = (path: string) => {
        navigate(path);
    };

    return {
        handleNavigate,
        i18n,
        windowWidth,
        getBreakpoint,
        userService,
        demo,
    };
};

export default useUsers;
